import { render, staticRenderFns } from "./NewMessengerConversationDetails.vue?vue&type=template&id=155eda5c&scoped=true"
import script from "./NewMessengerConversationDetails.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationDetails.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationDetails.vue?vue&type=style&index=0&id=155eda5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155eda5c",
  null
  
)

export default component.exports